import { icons } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/gameplay.css */
  .game_header.busted {
    margin-top: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .game_header.busted .game_title {
    background: hsla(0, 0%, 100%, 0.1);
    font-size: 1.3rem;
    padding: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  }
  .game_header.busted .game_title .icon {
    background: url(${icons.busted_icon}) left center / 22px auto no-repeat;
    width: 22px;
    height: 22px;
    margin: 0 5px 0 0;
  }
  .game_header.busted .game_title img {
    height: 20px;
  }
  .game_header.busted .busted_price_display {
    border-radius: 0 0 10px 10px;
    line-height: 100%;
    padding: 0;
    height: fit-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: fit-content;
  }
  .game_header.busted .busted_price_display span {
    padding: 10px 30px;
    width: fit-content;
    font-size: 5rem;
    font-weight: 500;
    font-family: 'Inter';
    letter-spacing: -0.09em;
    font-variant-numeric: tabular-nums;
    border-radius: 0 0 10px 10px;
  }
  .game_header.busted .busted_price_display.start span {
    background: hsl(158, 29%, 16%);
    color: hsl(126, 100%, 38%);
  }
  .game_header.busted .busted_price_display.busted span {
    background: hsl(330, 29%, 16%);
    color: hsl(340, 88%, 46%);
  }

  .game_header.busted .max_profit {
    background: hsla(0, 0%, 100%, 0.05);
    width: 100%;
    border-radius: 0;
    line-height: 100%;
    padding: 5px 20px;
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
  }
`

const developerCSS = css``

export const HeaderCSS = styled.div`
  /* position: absolute;
  top: 0;
  left: 50%; */
  /* transform: translateX(-50%); */
  ${designerCSS}
  ${developerCSS}
`
